import gql from 'graphql-tag';

export const UPDATE_CLOSE_REASON_STATUS = gql`
  mutation UpdateBPFCloseReasonStatus($id: ID!, $status: Boolean!) {
    bpf {
      result: updateCloseReasonActiveStatus(id: $id, status: $status) {
        error
        success
        entity {
          id
          type
          label
          flowId
          isActive
          createdDateTime
          modifiedDateTime
        }
      }
    }
  }
`;
